/**
 * Normalize performer Gmail draft links for the web UI.
 *
 * Gmail's older `#drafts?compose=` deep links often fail; `#inbox?compose=` with the
 * API message id is the reliable format.
 *
 * @example
 * normalizeGmailDraftUrl("https://mail.google.com/mail/u/0/#drafts?compose=abc123");
 * // "https://mail.google.com/mail/u/0/#inbox?compose=abc123"
 *
 * @example
 * normalizeGmailDraftUrl("https://mail.google.com/mail/u/0/#inbox?compose=abc123");
 * // "https://mail.google.com/mail/u/0/#inbox?compose=abc123"
 */
export const normalizeGmailDraftUrl = (url) => {
  const raw = String(url || "").trim();
  if (!raw) return "";
  try {
    const parsed = new URL(raw);
    if (!parsed.hostname.includes("mail.google.com")) {
      return raw;
    }
    let hash = parsed.hash || "";
    if (hash.startsWith("#drafts?")) {
      hash = hash.replace(/^#drafts\?/, "#inbox?");
    }
    parsed.hash = hash;
    return parsed.toString();
  } catch (_) {
    return raw;
  }
};

/**
 * True when a URL looks like a Gmail web mail draft/compose link.
 *
 * @example
 * isGmailDraftWebUrl("https://mail.google.com/mail/u/0/#inbox?compose=1a2b");
 * // true
 */
export const isGmailDraftWebUrl = (url) => {
  const normalized = normalizeGmailDraftUrl(url);
  if (!normalized) return false;
  try {
    const parsed = new URL(normalized);
    return (
      parsed.hostname.includes("mail.google.com") &&
      (parsed.hash.includes("compose=") || parsed.hash.includes("/drafts/"))
    );
  } catch (_) {
    return false;
  }
};
